import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Settings } from './../../core';
import { SiteShipmentSummaryData } from '../shipment-summary/shipment-summary-info';
import { map } from 'rxjs/operators';
import { dataMember, typedArray } from 'santee-dcts';
import { ShipmentData, SiteShippingInProgressModel } from '../interfaces/shipment-data';
import * as moment from 'moment';
import { Site } from '../../sites';

export class SiteShipmentSummaryReadModel {
    @dataMember()
    @typedArray(SiteShipmentSummaryData)
    public shipmentSummaryData: SiteShipmentSummaryData[];
}

export class ShipmentListModel {
    @dataMember()
    @typedArray(ShipmentData)
    public shipmentList: ShipmentData[];
}

export interface SiteShippingListRequest {
    fromDateRange?: moment.MomentInput;
    toDateRange?: moment.MomentInput;
}

@Injectable()
export class SiteShippingToolStorage {

    public siteShippingUrl = `${this.settings.apiUrl}/investigator/siteshipping`;

    constructor(
        private settings: Settings,
        private http: HttpClient) {
    }

    public getShipmentSummaryDetails(id: number): Observable<SiteShipmentSummaryData[]> {
        let request: { siteShipmentId: number } = { siteShipmentId: id };
        return this.http.post(`${this.siteShippingUrl}/siteshipmentsummary`, request).pipe(
            map((rawData: SiteShipmentSummaryReadModel) => {
                return rawData.shipmentSummaryData;
            })
        );
    }

    public getShipmentList(fromDate: string, toDate: string): Observable<ShipmentData[]> {
        let requestInfo: SiteShippingListRequest = {
            fromDateRange: fromDate,
            toDateRange: toDate
        };
        return this.http.post(`${this.siteShippingUrl}/submitted/list`, requestInfo).pipe(
            map((rawData: ShipmentListModel) => {
                return rawData.shipmentList;
            })
        );
    }

    public getInProgressShipmentList(sites: Site[]): Observable<ShipmentData[]> {
        let request = {
            siteIDList: sites.map(t => t.ctSiteId)
        };
        return this.http.post(`${this.siteShippingUrl}/inprogressshipment`, request).pipe(
            map((rawData: SiteShippingInProgressModel) => {
                return rawData.inProgressData;
            })
        );
    }

    public getProtocolList() {
        return this.http.get(`${this.siteShippingUrl}/protocolList`)
            .pipe(map((res: { protocolList: [{ protocolCode: string, sponsorName: string }] }) => { return res.protocolList; }));
    }

    public getSumbittedDataByProtocolList(request: { protocolCode: string, sponsorName: string, fromDateRange: string, toDateRange: string }) {
        return this.http.post(`${this.siteShippingUrl}/submitted/listbyprotocol`, request);
    }

}